const PATHS = {
  home: '/',
  login: '/login',
  verify: '/verify',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  products: '/products',
  productsNew: '/products/new',
  fundraisers: '/fundraisers',
  fundraisersNew: '/fundraisers/new',
  fundraisersEdit: '/fundraisers/:id/edit',
  orders: '/donations',
  orderDetail: '/donations/:id',

  transactions: '/transactions',
  transactionDetail: '/transactions/:id',
  payouts: '/payouts',
  payoutDetail: '/payouts/:id',
  refunds: '/refunds',
  disputes: '/disputes',
  disputeDetail: '/disputes/:id',
  webhooks: '/webhooks',
  webhookDetail: '/webhooks/:id',
  transfers: '/transfers',
  transferDetail: '/transfers/:id',
  clients: '/clients',
  clientDetail: '/clients/:id',
  integrations: '/integrations',
  companies: '/companies',
  companiesNew: '/companies/new',
  companyDetails: '/companies/:id',

  hailopayDashboard: '/hailopay-dashboard',
  profile: '/profile',
  welcome: '/welcome',
  checkout: '/store/:id/checkout',
  orderSuccess: '/order/:id/success',

  // Settings todo: enable after launch
  /* companyInfo: '/company-info',
  branding: '/branding',
  automation: '/automation',
  shipping: '/shipping',
  shippingEdit: '/shipping/:name', */
};

export default PATHS;
